import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

    static get targets() {
        return [
            "assignTo",
            "selectOrg",
            "assignToAll",
            "assignToOrg",
            "orgIds"
        ];
    }

    connect() {
        $.uf.initializeOrgTypeaheadRO(".multiple-orgs-typeahead");
        
        this.assignToAllTarget.addEventListener("change", this.assignToChecked.bind(this));
        this.assignToOrgTarget.addEventListener("change", this.assignToChecked.bind(this));

        this.assignToChecked();
    }

    assignToChecked() {
        if (this.assignToOrgTarget.checked) {
            this.selectOrgTarget.classList.remove("hide");
            this.orgIdsTarget.setAttribute("required", "required");
        } else if (this.assignToAllTarget.checked) {
            this.selectOrgTarget.classList.add("hide");
            this.orgIdsTarget.removeAttribute("required");
        }
    }
  }